const LINK_TARGETS = Object.freeze({
    CURRENT_TAB: 'currentTab',
    NEW_TAB: 'newTab',
});

export default LINK_TARGETS;